/**
 * @file Manages environment settings for the library.
 * @example
 * env.set("API_URL", "https://zed.bibleproject.com");
 */

export const NAMESPACE = "__bp__";

let state: Pick<LibrarySettings, "env"> = {
  env: {
    API_URL: process.env.API_URL ?? "/services/graphql/",
    DEBUG: process.env.NODE_ENV !== "development",
    LANGUAGE: process.env.LANGUAGE ?? "en",
    USER_API_URL: process.env.USER_API_URL ?? "/services/current-user/",
    NEWSLETTER_API_URL:
      process.env.NEWSLETTER_API_URL ?? "/services/newsletter/",
    ROOT: process.env.ROOT,
  },
};

export function get<K extends keyof Env>(key: K, fallback?: Env[K]) {
  return state.env[key] ?? fallback;
}

export function set<K extends keyof Env>(key: K, value: Env[K]) {
  state.env[key] = value;
}

export function initializeState(
  currentState: LibrarySettings,
  existingState?: LibrarySettings,
) {
  if (existingState) {
    for (const [key, value] of Object.entries(currentState.env) as [
      keyof LibrarySettings["env"],
      string,
    ][]) {
      if (typeof existingState.env[key] === "undefined") {
        // @ts-expect-error
        existingState.env[key] = value;
      }
    }
    return existingState;
  }

  return currentState;
}

if (typeof window !== "undefined") {
  state = window[NAMESPACE] = initializeState(state, window[NAMESPACE]);
}
